import units from '@/sui/data/units'
import tools from '@/sui/data/sheets/edit/tools'
import fields from '@/sui/data/sheets/edit/fields'
import go from '@/gojs/go'

const select = {
  bact: tools.equals(fields.expManagment, 1),
  pneu: tools.equals(fields.expManagment, 2),
  sep: tools.equals(fields.expManagment, 3),
  notSep: tools.different(fields.expManagment, 3)
}

const expManagment = tools.cfg.list(
  fields.expManagment, 'Type de fiche', [], {
    ini: function (vm) {
      const s = vm.surveillance
      const ufs = s.modules.expADI.ufs
      let hasNeo = false
      const uy = units[s.year]
      for (let i = 0; i !== ufs.length; ++i) {
        const uf = ufs[i]
        if (uy.isNeo(uf.ufType) || uy.isMix(uf.ufType)) {
          hasNeo = true
          break
        }
      }

      this.config.values = go.fields.expManagment.filter(e => e.code <= 2 || hasNeo)
    }
  }
)

const covidStatus = (function () {
  function build (t) {
    return tools.cfg.list(
      fields.covidStatus, t, go.fields.covidStatus
    )
  }
  return {
    std: build('Statut COVID'),
    exit: build('Statut COVID en fin de séjour')
  }
})()

export default {
  select,
  expManagment,
  covidStatus
}
